//Found and modified (added debounce) from https://tobbelindstrom.com/blog/resize-observer-hook/
import { useRef, useLayoutEffect, useState, useCallback } from "react";

function debounce(fn, ms) {
  let timer;
  return (_) => {
    clearTimeout(timer);
    timer = setTimeout((_) => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
}

const useResizeObserver = (timeout) => {
  const [observerEntry, setObserverEntry] = useState({});
  const [node, setNode] = useState(null);
  const observer = useRef(null);

  const disconnect = useCallback(() => observer.current?.disconnect(), []);

  const observe = debounce(
    useCallback(() => {
      observer.current = new ResizeObserver(([entry]) =>
        setObserverEntry(entry)
      );
      if (node) observer.current.observe(node);
    }, [node]),
    timeout
  );

  useLayoutEffect(() => {
    observe();
    return () => disconnect();
  }, [disconnect, observe]);

  return [setNode, observerEntry];
};

export default useResizeObserver;
